import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSelectedAudioItem} from '@Hooks/poster-editor/useSelectedAudioItem';
import {useAppSelector} from '@/hooks';

interface AudioSpeedOptionProps {
  className?: string;
}
export function AudioSpeedOption({className = ''}: AudioSpeedOptionProps): ReactElement<any> | null {
  const selectedAudioItem = useSelectedAudioItem();
  const posterDuration = useAppSelector((state) => {
    return state.posterEditor.posterObject?.duration;
  });

  if (!selectedAudioItem || !posterDuration) {
    return null;
  }

  const updateAudioItemSpeed = async (speed: number, undoable: boolean): Promise<void> => {
    await selectedAudioItem.updateFromObject(
      {
        audioPlayer: {
          speed,
        },
      },
      {
        undoable,
      }
    );
  };

  const onSpeedEndHandler = async (val: number): Promise<void> => {
    selectedAudioItem.clipAudioExceedingPageDuration();
    selectedAudioItem.audioPlayer.ensureFadeIsInLimits();
    selectedAudioItem.audioClips.page.poster.redux.updateReduxData();
    await updateAudioItemSpeed(val, true);
  };

  const getSpeedControlSlider = (): ReactElement<any> => {
    return (
      <ContextualMenuSliderOptions
        id="audio-speed-option"
        className={className}
        range={{
          min: 0.5,
          max: 4,
        }}
        transformDisplay={{
          min: 0.5,
          max: 4,
        }}
        step={0.25}
        value={selectedAudioItem.audioPlayer.speed}
        label={`${window.i18next.t('pmwjs_speed')}`}
        onChange={(val: number): void => {
          void updateAudioItemSpeed(val, false);
        }}
        onChangeEnded={(val: number): void => {
          void onSpeedEndHandler(val);
        }}
      />
    );
  };

  return getSpeedControlSlider();
}
